import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { CONTACT } from "@/data/content";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-black/10 bg-[color:var(--surface)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-8 font-serif text-3xl md:text-4xl leading-[1.15] text-[color:var(--bone)] max-w-md">
              Capital for the businesses that build the country.
            </p>
            <Link
              to="/apply"
              className="inline-flex items-center gap-2 mt-8 border-b border-[color:var(--gold)] pb-1 font-mono text-xs tracking-[0.24em] uppercase text-[color:var(--gold)]"
            >
              Start your application →
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-6">Explore</div>
            <ul className="space-y-3 text-[color:var(--bone)]/80">
              <li><Link to="/products" className="gold-link">Products</Link></li>
              <li><Link to="/process" className="gold-link">Process</Link></li>
              <li><Link to="/resources" className="gold-link">Resources</Link></li>
              <li><Link to="/blog" className="gold-link">Blog</Link></li>
              <li><Link to="/deal-structures" className="gold-link">Deal Structures</Link></li>
              <li><Link to="/faq" className="gold-link">FAQ</Link></li>
              <li><Link to="/about" className="gold-link">About</Link></li>
              <li><Link to="/contact" className="gold-link">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-6">Contact</div>
            <ul className="space-y-3 font-mono text-sm text-[color:var(--bone)]/80">
              <li>Main <span className="text-[color:var(--bone)] ml-3">{CONTACT.mainPhone}</span></li>
              <li>Direct <span className="text-[color:var(--bone)] ml-3">{CONTACT.directPhone}</span></li>
              <li>Fax <span className="text-[color:var(--bone)] ml-3">{CONTACT.fax}</span></li>
              <li className="pt-2"><a href={`mailto:${CONTACT.email}`} className="gold-link">{CONTACT.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-6 border-t border-black/10 flex flex-col md:flex-row justify-between text-xs font-mono tracking-wider text-[color:var(--bone)]/45 gap-2">
          <div>© {year} Steady Path Funding · All rights reserved</div>
          <div className="flex items-center gap-3">
            <span>Brokerage disclosure</span>
            <span aria-hidden="true">·</span>
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[color:var(--gold)] transition-colors">
              Privacy
            </Link>
            <span aria-hidden="true">·</span>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[color:var(--gold)] transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
